import Colors from "../../theme/colors/Colors.palette";

export interface ILogoProps {
  color?: string;
  width?: number;
}
export interface ILogoStoryProps extends ILogoProps {
  backgroundColor?: string;
  isMobile?: boolean;
}

export const DefaultLogoProps = {
  color: Colors.Essential.white,
  width: 150,
};
